// extracted by mini-css-extract-plugin
export default {"labelledIconButton":"labelledIconButton-DJXCN","horizontalNav":"horizontalNav-vNOyy","blackAndWhite":"blackAndWhite-yKULD"};